// extracted by mini-css-extract-plugin
module.exports = {"actions":"CardKleeActions_actions__6F8a1","noPadding":"CardKleeActions_noPadding__w2AqX"};